import { useCallback, useEffect, useState, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setIsLoading, setWorkIn, setLeaveonday } from "../slices/employeeSlice";
import * as services from "../services/employeeApi"
import dayjs from "dayjs"
import { useTranslation } from "react-i18next";
import EmployeeWorkInWorkInTable from "components/table/EmployeeWorkInWorkInTable";
import useEmployeeWorkIn from "./useEmployeeWorkIn";
import { useParams } from "react-router-dom";
import { dataURLtoFile, generateRandomString } from "utils/helper";
import { Modal, Flex } from "antd";
import { Alert } from "components/elements";
import {
  MY_REQUEST_TYPE
} from "../../myDocument/schemas/myRequestSchema";

import { setCurrentOvertime } from "../../myDocument/slices/myDocumentSlice";

import * as employeeServices from "features/employee/services/employeeApi";
import * as masterDataServices from "features/masterData/services/optionsApi";
import ModalWorkinClockingIn from "components/elements/Modal/ModalWorkinClockingIn";
import LeaveForm from "features/myDocument/components/LeaveForm";
import OffsiteForm from "features/myDocument/components/OffsiteForm";
import RedeemTimeForm from "features/myDocument/components/RedeemTimeForm";
import EndorseTimeForm from "features/myDocument/components/EndorseTimeForm";
import OvertimeForm from "features/myDocument/components/OvertimeForm";
import CollectTimeForm from "features/myDocument/components/CollectTimeForm";
import DocumentForm from "features/myDocument/components/DocumentForm";

const MODAL_TYPE = {
  CREATE: "create",
  EDIT: "edit",
  VIEW: "view",
};

//* grey red green yellow
function useEmployeeWorkInWorkIn() {
  const dispatch = useDispatch()
  const [selectedMenu, setMenu] = useState(MY_REQUEST_TYPE.LEAVE);
  const { getPage = () => { } } = useEmployeeWorkIn()
  const { workIn, isLoading } = useSelector((state) => state.employee)
  const { currentCompany, currentEmployee } = useSelector((state) => state.company)
  const [startDate, setStartDate] = useState(dayjs().startOf("month"))
  const [endDate, setEndDate] = useState(dayjs())
  const [selectedDates, setSelectedDates] = useState(null);
  const [pagination, setPagination] = useState({ page: 0, size: 10 });
  const [search, setSearch] = useState();
  const [currentMyRequest, setCurrentMyRequest] = useState({});
  const [visible, setVisible] = useState(false);
  const [modalData, setModalData] = useState(null);
  const [modalType, setModalType] = useState("");
  const [penaltiesOptions, setPenaltiesOptions] = useState([]);
  const [title, setTitle] = useState([]);
  const [work, setWork] = useState([]);
  const { i18n, t } = useTranslation();
  const [lang, setLang] = useState("en");
  const [isModalOpen, setModalOpen] = useState(false);
  const [offSiteOptions, setOffSiteOptions] = useState([]);
  const [leaveGroupOptions, setLeaveGroupOptions] = useState([]);
  const [documentTypeOptions, setDocumentTypeOptions] = useState([]);
  const [employeeOptions, setEmployeeOptions] = useState([]);
  const [files, setFiles] = useState([]);
  const [previousFile, setpreviousFilew] = useState(null);



  const [countryOptions, setCountryOptions] = useState([]);
  const [remainingLeaveDays, setremainingLeaveDays] = useState([]);
  const params = useParams();
  const { id } = useParams();
  const currentOvertime = useSelector((state) => state.myDocument.currentOvertime);

  const collectTimeDropdown = useSelector(
    (state) => state.myDocument.collectTime || []
  );

  const companyRegulation = useSelector(
    (state) => state.myDocument.companyRegulations || []
  );


  const [isModalClockingOpen, setIsModalClockingOpen] = useState(false);


  const onDeleteFile = () => {
    setpreviousFilew(null);
  }

  const handleDateChange = (dates) => {
    setSelectedDates(dates);
  };

  const handleApply = () => {
    // if (selectedDates && selectedDates.length === 2) {
    let monthDate = dayjs();
    getWorkInList({
      startDate: selectedDates?.[0]?.format?.("YYYY-MM-DD") || monthDate.startOf("month").format("YYYY-MM-DD"),
      endDate: selectedDates?.[1]?.format?.("YYYY-MM-DD") || monthDate.format("YYYY-MM-DD"),
    });
    // }
  };


  const onAttachFileChange = async ({
    attachFile,
    setFieldValue,
    setImageUrl,
    seeFileName,
    initialValuesImageUrl,
    initialValuesFileName,
    initialValuesFileType,
    initialValuesFileList,
    setInitialValuesFileName,
    setInitialValuesFileType,
    setInitialValuesImageUrl,
    setInitialValuesFileList,
    setFileType
  }) => {
    const fileUrls = [...initialValuesImageUrl];
    const fileNames = [...initialValuesFileName];
    const fileList = [...initialValuesFileList];
    const fileTypes = [...initialValuesFileType];
    const attachFileList = attachFile?.file;

    // for (let index = 0; index < attachFileList.length; index++) {
    //   const element = attachFileList[index];

    // if (previousFile && element?.name === previousFile[index].name && element?.size === previousFile[index].size) {
    //   return;
    // }

    try {
      const allowedTypes = ["image/png", "image/jpeg", "application/pdf", "application/vnd.ms-excel"];
      const fileType = attachFileList?.type;
      const fileSize = attachFileList?.size;
      fileTypes.push(fileType)
      if (!allowedTypes.includes(fileType)) {
        Modal.error({
          title: "File Upload Error",
          content: "Unsupported file type. Only PNG, JPEG, XLS, and PDF are allowed.",
          okText: "Close",
          okButtonProps: { style: { height: "40px", borderRadius: "8px", backgroundColor: "var(--button-color)", boxShadow: "none" } },
        });
        // setIsProcessing(false);
        return;
      }

      // const maxSize = 1 * 1024 * 1024;
      // // console.log("🚀 ~ useMyRequest ~ maxSize:", maxSize)
      // if (fileSize > maxSize) {
      //   Modal.error({
      //     title: "File Upload Error",
      //     content: "File size exceeds the 1 MB limit.",
      //     okText: "Close",
      //     okButtonProps: { style: { height: "40px", borderRadius: "8px", backgroundColor: "var(--button-color)", boxShadow: "none" } },
      //   });
      //   // setIsProcessing(false);
      //   return;
      // }
      console.log("fileType", fileType
        , fileUrls
        , fileNames
        , fileList
      );

      if (fileType === "application/pdf" || fileType === "application/vnd.ms-excel") {
        const base64 = await new Promise((resolve) => {
          const reader = new FileReader();
          reader.readAsDataURL(attachFileList?.originFileObj);
          reader.onload = () => resolve(reader.result);
        });

        const filename = `${Date.now()}_${attachFileList?.name}`;
        const file = dataURLtoFile(base64, filename);
        fileUrls.push(base64)
        fileNames.push(filename)
        fileList.push(file)
      } else {
        // const compressImg = await service.compressedImage({
        //   file: attachFileList?.originFileObj,
        // });

        const base64 = await new Promise((resolve) => {
          const reader = new FileReader();
          // reader.readAsDataURL(compressImg.data);
          reader.onload = () => resolve(reader.result);
        });

        const filename = `${Date.now()}_${attachFileList?.name}`;
        const file = dataURLtoFile(base64, filename);

        fileUrls.push(base64)
        fileNames.push(filename)
        fileList.push(file)
      }
    } catch (error) {
      Modal.error({
        title: "File Upload Error",
        content: error.message,
        okText: "Close",
        okButtonProps: { style: { height: "40px", borderRadius: "8px", backgroundColor: "var(--button-color)", boxShadow: "none" } },
      });
      // setIsProcessing(false);
      return;
    }
    // }

    setpreviousFilew(attachFileList);
    setFiles(fileList);
    seeFileName(fileNames);
    setInitialValuesFileName(fileNames);
    setInitialValuesFileType(fileTypes);
    setInitialValuesImageUrl(fileUrls);
    setInitialValuesFileList(fileList);
    setFieldValue("attachFile", fileList);
    setFieldValue("attachFileType", fileTypes);
    setFieldValue("attachFileName", fileNames);
    setImageUrl(fileUrls);
    setFileType?.(fileTypes)

  };

  const getDocumentTypeOptions = useCallback(async () => {
    if (typeof currentCompany !== "object") {
      try {
        dispatch(setIsLoading(true));
        const values = {
          requestId: generateRandomString(),
          companyId: currentCompany,
        };
        const response = await masterDataServices.getDocumentTypeOptions(
          values
        );
        setDocumentTypeOptions(response.data);
      } catch (error) {
        Alert({ type: "error", resultObject: error });
      } finally {
        dispatch(setIsLoading(false));
      }
    }
  }, [currentCompany, dispatch]);


  const getCountryOptions = useCallback(async () => {
    if (typeof currentCompany !== "object") {
      try {
        dispatch(setIsLoading(true));
        const values = {
          requestId: generateRandomString(),
        };
        const response = await masterDataServices.getCountryOptions(values);
        setCountryOptions(response.data);
      } catch (error) {
        Alert({ type: "error", resultObject: error });
      } finally {
        dispatch(setIsLoading(false));
      }
    }
  }, [currentCompany, dispatch]);


  const getOffSiteOptions = useCallback(async () => {
    if (typeof currentCompany !== "object") {
      try {
        dispatch(setIsLoading(true));
        const values = {
          requestId: generateRandomString(),
          companyId: currentCompany,
          employeeId: id,
        };
        const response = await masterDataServices.getLeaveGroupIsOffSite(
          values
        );
        setOffSiteOptions(response.data);
      } catch (error) {
        Alert({ type: "error", resultObject: error });
      } finally {
        dispatch(setIsLoading(false));
      }
    }
  }, [currentCompany, dispatch]);


  const getLeaveGroupOptions = useCallback(async () => {
    if (typeof currentCompany !== "object") {
      try {
        dispatch(setIsLoading(true));
        const values = {
          requestId: generateRandomString(),
          companyId: currentCompany,
          employeeId: id,
        };
        const response = await masterDataServices.getLeaveGroupIsLeave(values);
        setLeaveGroupOptions(response.data);
      } catch (error) {
        Alert({ type: "error", resultObject: error });
      } finally {
        dispatch(setIsLoading(false));
      }
    }
  }, [currentCompany, currentEmployee, dispatch]);


  const getEmployeeOptions = useCallback(async () => {
    if (typeof currentCompany !== "object") {
      try {
        dispatch(setIsLoading(true));
        const values = {
          requestId: generateRandomString(),
          companyId: currentCompany,
        };
        const response = await employeeServices.getDropDown(values);
        setEmployeeOptions(response.data);
      } catch (error) {
        Alert({ type: "error", resultObject: error });
      } finally {
        dispatch(setIsLoading(false));
      }
    }
  }, [currentCompany, dispatch]);

  const getCompanyOvertime = useCallback(async () => {
    try {
      dispatch(setIsLoading(true));
      const response = await services.getOvertimeCondition({
        requestId: generateRandomString(),
        companyId: currentCompany,
      });
      // console.log(response.data)
      dispatch(setCurrentOvertime(response.data));
      // console.log(currentOvertime.otReqCondition);
    } catch (error) {
      alert({ type: "error", resultObject: error });
    } finally {
      dispatch(setIsLoading(false));
    }
  }, [currentCompany, dispatch]);



  const handleMenuChange = (type) => {
    setMenu(type);
    console.log("selectedMenu recieve", type);
    console.log("selectedMenu", selectedMenu);
  }


  const modifiedPenaltiesOptions = useMemo(() => {
    return penaltiesOptions?.map((opt) => ({
      ...opt,
      label: lang === "en" ? opt?.nameEn : opt?.name,
      value: opt?.id,
    }));
  }, [lang, penaltiesOptions]);


  const handleClose = () => {
    setVisible(false);
  };



  const modifiedDocumentTypeOptions = useMemo(() => {
    return documentTypeOptions?.map((opt) => ({
      ...opt,
      label: lang === "en" ? opt?.nameEn : opt?.name,
      value: opt?.id,
    }));
  }, [lang, documentTypeOptions]);

  const modifiedCountryOptions = useMemo(() => {
    return countryOptions?.map((opt) => ({
      ...opt,
      label: lang === "en" ? opt?.nameEn : opt?.name,
      value: opt?.id,
    }));
  }, [lang, countryOptions]);


  const modifiedEmployeeOptions = useMemo(() => {
    return employeeOptions?.map((opt) => ({
      ...opt,
      label: lang === "en" ? opt?.fullNameEn : opt?.fullName,
      value: opt?.id,
    }));
  }, [lang, employeeOptions]);

  const modifiedLeaveGroupOptions = useMemo(() => {
    return leaveGroupOptions?.map((opt) => ({

      ...opt,
      unlimited: opt?.unlimited ? opt?.unlimited : 'N',
      emergencyFlag: opt?.emergencyFlag ? opt?.emergencyFlag : 'N',
      emergencyUsed: opt?.emergencyUsed ? opt?.emergencyUsed : 0,
      remainingLeaveDays: opt?.remainingLeaveDays,
      remainingLeaveHour: opt?.remainingLeaveHour,
      label: lang === "en" ? opt?.leaveTypeNameEn : opt?.leaveTypeName,
      value: opt?.leaveId,
    }));
  }, [lang, leaveGroupOptions]);







  const modifiedOffSiteOptions = useMemo(() => {
    return offSiteOptions?.map((opt) => ({
      ...opt,
      label: lang === "en" ? opt?.nameEn : opt?.name,
      value: opt?.id,
    }));
  }, [lang, offSiteOptions]);


  const getWorkInList = useCallback(async (params) => {
    try {
      dispatch(setIsLoading(true));
      const start = params?.startDate || startDate?.format("YYYY-MM-DD");
      const end = params?.endDate ||
        (endDate.isAfter(dayjs()) ? dayjs().format("YYYY-MM-DD") : endDate?.format("YYYY-MM-DD"));

      const response = await services.getWorkIn({
        startDate: start,
        endDate: end,
        companyId: currentCompany,
        employeeId: id,
        actionId: currentEmployee,
        page: 0,
        size: (dayjs(end).diff(dayjs(start), 'day')) + 1,
        ...params
      });

      dispatch(setWorkIn(response?.data?.content));
      getTable();
      getPage();
    } catch (error) {
      alert({ type: "error", resultObject: error });
    } finally {
      dispatch(setIsLoading(false));
    }
  }, [currentCompany, currentEmployee, id, startDate, endDate, dispatch, getPage]);


  const getMyRequest = useCallback(async (record = {}, type) => {
    let param = {
      requestId: generateRandomString(),
      companyId: currentCompany,
      employeeId: params?.id ? params?.id : currentEmployee,
    };
    let data = {};
    console.log("selectedMenu ", selectedMenu);
    dispatch(setIsLoading(true));
    switch (type) {
      case MY_REQUEST_TYPE.LEAVE:
        data = await services.getLeaveRequestByIdRequest({
          ...param,
          leaveRequestId: record.leaveRequestId,
        });
        dispatch(setIsLoading(false));

        return {
          ...data,
        };
      case MY_REQUEST_TYPE.OFFSITE_WORK:
        data = await services.getOffsiteWorkRequestByIdRequest({
          ...param,
          offsiteWorkRequestId: record.offsiteWorkRequestId,
        });
        dispatch(setIsLoading(false));

        return {
          ...data,
          startDate: dayjs(data?.startDate),
          endDate: dayjs(data.endDate),
        };
      case MY_REQUEST_TYPE.REDEEM_TIME:
        data = await services.getRedeemTimeRequestByIdRequest({
          ...param,
          redeemTimeRequestId: record.redeemTimeRequestId,
        });
        dispatch(setIsLoading(false));

        return {
          ...data,
          redeemDate: dayjs(data.redeemDate),
        };
      case MY_REQUEST_TYPE.ENDORSE_TIME:
        data = await services.getEndorseTimeRequestByIdRequest({
          ...param,
          endorseTimeRequestId: record.endorseTimeRequestId,
          endorseMentDate: record.endorseMentDate
        });
        dispatch(setIsLoading(false));

        return {
          ...data,
          endorseMentDate: dayjs(data.timeEndorsementDate),
        };
      case MY_REQUEST_TYPE.OVERTIME:
        data = await services.getOvertimeRequestByIdRequest({
          ...param,
          overtimeRequestId: record.overtimeRequestId,
        });
        dispatch(setIsLoading(false));

        return {
          ...data,
          startDate: dayjs(data?.startDate),
        };
      case MY_REQUEST_TYPE.COLLECT_TIME:

        data = await services.getCollectTimeRequestByIdRequest({
          ...param,
          collectTimeRequestId: record.collectTimeRequestId,
        });
        dispatch(setIsLoading(false));
        return { ...data, startDate: dayjs(data.startDate) };
      case MY_REQUEST_TYPE.DOCUMENT_REQUEST:
        data = await services.getDocumentRequestByIdRequest({
          ...param,
          documentRequestId: record.documentRequestId,
        });
        dispatch(setIsLoading(false));
        return {
          ...data,
          preferredDate: dayjs(data.preferredDate),
          travelDate: dayjs(data.travelDate),
        };
      default:
        // dispatch(setIsLoading(false));
        return {};
    }

  }, [selectedMenu]);


  const getWorkInDetail = useCallback(async (params) => {
    try {
      dispatch(setIsLoading(true));
      const start = params?.date
      const end = params?.date

      const response = await services.getWorkInDetail({
        startDate: start,
        endDate: end,
        companyId: currentCompany,
        employeeId: id,
        actionId: currentEmployee,
        // page: 0,
        // size: (dayjs(end).diff(dayjs(start), 'day')) + 1,
        ...params
      });

      setWork(response?.data?.content);
      // getTable();
      // getPage();
    } catch (error) {
      alert({ type: "error", resultObject: error });
    } finally {
      dispatch(setIsLoading(false));
    }
  }, [currentCompany, currentEmployee, id, dispatch, setWork]);


  const showModalClocking = (work) => {
    getWorkInDetail(work);
    setTitle(work);
    setIsModalClockingOpen(true);
    // setWork(work);
  };


  const onDownload = useCallback(
    async () => {
      try {
        console.log("onDownload");
        dispatch(setIsLoading(true));
        let monthDate = dayjs();
        const res = await services.ExportWorkingTimeGroupReportPagingeByEmp({
          companyId: currentCompany,
          ...search,
          ...pagination,
          startDate: selectedDates?.[0]?.format?.("YYYY-MM-DD") || monthDate.startOf("month").format("YYYY-MM-DD"),
          endDate: selectedDates?.[1]?.format?.("YYYY-MM-DD") || monthDate.format("YYYY-MM-DD"),
          isReport: "Y",
          employeeId: id
        });
        console.log("res ", res);

        if (res && res.data) {
          const url = window.URL.createObjectURL(res.data);
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', "WorkingTimeReport.xlsx");

          document.body.appendChild(link);
          link.click();
          link.remove();

          window.URL.revokeObjectURL(url);
        } else {
          console.error("No data received for the download.");
        }
      } catch (error) {
        console.error("Error fetching report history:", error);
      } finally {
        dispatch(setIsLoading(false));
      }
    },
    [currentCompany, selectedDates, search, pagination, id, dispatch]
  );

  const modifiedCollectTimeOptions = useMemo(() => {
    return collectTimeDropdown?.map((opt) => (
      {
        ...opt,
        label: opt?.collectDate,
        value: opt?.id,
      }
    ))
  }, [collectTimeDropdown])

  const modifiedCompanyRegulationOptions = useMemo(() => {
    return companyRegulation?.map((opt) => ({
      ...opt,
      label: lang === "en" ? opt?.nameEn : opt?.name,
      value: opt?.id,
    }));
  }, [lang, companyRegulation]);




  const onView = useCallback(async (record, type) => {
    setMenu(type);
    setModalType(MODAL_TYPE.VIEW);
    let editingData = await getMyRequest(record, type);
    setCurrentMyRequest({ ...editingData?.data });
    setModalOpen(true);
  }, [getMyRequest])



  // function onDraft(values) {
  //   onSubmit({ ...values, sendingType: "DRAFT" });
  // }

  const onCancel = () => {
    setModalOpen(false);
    // setSwitchWith(null)
  };

  const getTable = useCallback(() => {
    return (
      <EmployeeWorkInWorkInTable
        isLoading={isLoading}
        handleMenuChange={handleMenuChange}
        onView={onView}
        getWorkInList={getWorkInList}
        // getMyRequest={getMyRequest}
        // getMyoffSiteRequest={getMyoffSiteRequest}
        // getOtRequest={getOtRequest}
        // getEndorseTimeRequest={getEndorseTimeRequest}
        // getModal={MyRequestModal}
        // isLoading={isLoading}
        visible={visible}
        modalData={modalData}
        dataSource={workIn?.map((o) => ({
          ...o,
          children: o?.children?.size > 0 ? o?.children : null,
        }))}
        pagination={false}
        showModalClocking={showModalClocking}
      />
    );
  }, [isLoading, workIn, onView, handleMenuChange]);

  const modalProps = useMemo(() => {
    switch (selectedMenu) {
      case MY_REQUEST_TYPE.LEAVE:
        return {
          title:
            <Flex vertical>{t('leave-request')}
              <span style={{ color: "#667085", fontWeight: "normal", fontSize: "14px" }}>{t("leave_request.create.modal")}</span></Flex>,
          width: 510,
          content: (
            <LeaveForm
              setremainingLeaveDays={setremainingLeaveDays}
              initialValues={currentMyRequest}
              leaveGroupOptions={modifiedLeaveGroupOptions}
              // onDraft={onDraft}
              onCancel={onCancel}
              // onSubmit={onSubmit}
              // onDeleteFile={onDeleteFile}
              modalType={modalType}
              onAttachFileChange={onAttachFileChange}
            // onDelete={onDelete}
            />
          ),
        };
      case MY_REQUEST_TYPE.OFFSITE_WORK:
        return {
          title: t('offsite_work_request'),
          width: 510,
          content: (
            <OffsiteForm
              initialValues={currentMyRequest}
              modifiedOffSiteOptions={modifiedOffSiteOptions}
              // onDraft={onDraft}
              modalType={modalType}
              onCancel={onCancel}
              // onSubmit={onSubmit}
              // onDelete={onDelete}
              onAttachFileChange={onAttachFileChange}
            />
          ),
        };
      case MY_REQUEST_TYPE.REDEEM_TIME:
        return {
          title: t('redeem-time-request'),
          width: 510,
          content: (
            <RedeemTimeForm
              initialValues={currentMyRequest}
              // onDraft={onDraft}
              onCancel={onCancel}
              modalType={modalType}
              // onSubmit={onSubmit}
              collectTimeOptions={modifiedCollectTimeOptions}
            />
          ),
        };
      case MY_REQUEST_TYPE.ENDORSE_TIME:
        return {
          title: t('endorse-time-request'),
          width: 510,
          content: (
            <EndorseTimeForm
              initialValues={currentMyRequest}
              // onDraft={onDraft}
              modalType={modalType}
              onCancel={onCancel}
              // onSubmit={onSubmit}
              // onDeleteFile={onDeleteFile}
              onAttachFileChange={onAttachFileChange}
            // onDelete={onDelete}
            />
          ),
        };
      case MY_REQUEST_TYPE.OVERTIME:
        return {
          title: t('ot_request'),
          width: 510,
          content: (
            <OvertimeForm
              initialValues={currentMyRequest}
              currentOvertime={currentOvertime}
              // onDraft={onDraft}
              onCancel={onCancel}
              // onSubmit={onSubmit}
              // onDeleteFile={onDeleteFile}
              modalType={modalType}
              onAttachFileChange={onAttachFileChange}
            // onDelete={onDelete}
            />
          ),
        };
      case MY_REQUEST_TYPE.COLLECT_TIME:
        return {
          title: t('collect-time-request'),
          width: 510,
          content: (
            <CollectTimeForm
              initialValues={currentMyRequest}
              // onDraft={onDraft}
              modalType={modalType}
              onCancel={onCancel}
            // onSubmit={onSubmit}
            />
          ),
        };
      case MY_REQUEST_TYPE.DOCUMENT_REQUEST:
        return {
          title: t('document_request.header'),
          width: 510,
          content: (
            <DocumentForm
              initialValues={currentMyRequest}
              documentTypeOptions={modifiedDocumentTypeOptions}
              countryOptions={modifiedCountryOptions}
              modalType={modalType}
              // onDraft={onDraft}
              onCancel={onCancel}
            // onSubmit={onSubmit}
            />
          ),
        };
      default:
        return {};
    }
  }, [selectedMenu, t, currentMyRequest, modifiedLeaveGroupOptions, modalType, modifiedOffSiteOptions, modifiedCollectTimeOptions, currentOvertime, modifiedDocumentTypeOptions, modifiedCountryOptions, startDate, modifiedPenaltiesOptions, modifiedCompanyRegulationOptions, setMenu]);


  useEffect(() => {
    setLang(i18n.language);
  }, [i18n.language, setLang]);


  useEffect(() => {
    getWorkInList();
  }, [currentCompany, currentEmployee]);


  useEffect(() => {
    if (currentCompany) {
      getCompanyOvertime();
      getLeaveGroupOptions();
      getOffSiteOptions();
      getEmployeeOptions();
      getDocumentTypeOptions();
      getCountryOptions();
    }

  }, [currentCompany, getCompanyOvertime, getCountryOptions, getDocumentTypeOptions, getEmployeeOptions, getLeaveGroupOptions, getOffSiteOptions]);

  return {
    handleMenuChange,
    getWorkInList,
    getTable,
    handleDateChange,
    handleApply,
    onDownload,
    modalProps,
    isModalOpen,
    onCancel,
    isModalClockingOpen,
    setIsModalClockingOpen,
    showModalClocking,
    modalData,
    modalType,
    handleClose,
    work,
    title,
    visible,
    isLoading
  };
}

export default useEmployeeWorkInWorkIn;